module.exports = __webpack_public_path__ + "static/media/0023_IMG_LE_PLAFOND_RAL_9010.84df3eb4.png";